import { disconnect } from 'wagmi/actions'
import type { Config } from 'wagmi'

import { clearWalletPersistedSession } from './walletStorage'

/**
 * Desconecta la wallet y, si el conector falla, limpia sesión persistida para no dejar
 * al usuario atrapado (mismo efecto que limpiar `localStorage` manualmente).
 */
export async function disconnectWalletSafe(config: Config): Promise<void> {
  try {
    await disconnect(config)
  } catch {
    /* conector roto o sin provider: seguir con limpieza */
  }
  clearWalletPersistedSession()
}
